import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-row">
          {/* Left Content - 7 columns (58.33%) */}
          <div className="about-content">
            <div className="about-inner">
              <h4 className="about-subtitle">About Us</h4>
              <h1 className="about-title">
                Providing you with the highest quality electrical services
              </h1>
              
              <div className="about-features">
                <div className="feature-item">
                  <span className="feature-icon">⚡</span>
                  <h4>Emergency Power Solution</h4>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">🏗️</span>
                  <h4>Full-Service Electrical Layout</h4>
                </div>
              </div>

              <p className="about-description">
                Musa Electrical is your trusted partner for all electrical needs. With over 5 years of experience,
                we specialize in delivering top-quality electrical installations, maintenance, and repair services
                for residential, commercial, and industrial clients across Kenya.
              </p>

              <div className="about-checklist">
                <div className="check-item">
                  <span className="check-icon">✓</span>
                  <p>Installed, maintained and repaired lighting for clients</p>
                </div>
                <div className="check-item">
                  <span className="check-icon">✓</span>
                  <p>Solar panel installation - increasingly popular way to generate electricity</p>
                </div>
                <div className="check-item">
                  <span className="check-icon">✓</span>
                  <p>Protect electrical devices from damage with proper installation</p>
                </div>
                <div className="check-item">
                  <span className="check-icon">✓</span>
                  <p>Professional CCTV and security system installation</p>
                </div>
              </div>

              <Link to="/contact" className="about-btn">Contact Us</Link>
            </div>
          </div>

          {/* Right Images - 5 columns (41.67%) */}
          <div className="about-images">
            <div className="images-wrapper">
              {/* Main large image */}
              <img
                src={process.env.PUBLIC_URL + "/images/about/about-main.jpg"}
                alt="Electrical Work"
                className="main-image"
              />
              
              {/* Experience badge - bottom left */}
              <div className="experience-badge">
                <div className="badge-inner">
                  <h2>5+</h2>
                  <p>Years of Experience</p>
                </div>
              </div>
              
              {/* Secondary image - bottom right */}
              <div className="secondary-image-wrap">
                <img
                  src={process.env.PUBLIC_URL + "/images/about/about-secondary.jpg"}
                  alt="Musa Electrical Team"
                  className="secondary-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
